module.exports = __webpack_public_path__ + "web_static/img/getting_here.a5165f17.png";